import React from 'react'
import EmptyListUI from '../../../widgets/output/EmptyListUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import SuperUserTxnPageUI from '../../../templates/SuperUserTxnPageUI.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import PendingTxnListUI from '../../../components/superUser/nodalTxn/PendingTxnListUI'
import DailyPaymentsReportUI from '../../../components/superUser/nodalTxn/DailyPaymentsReportUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import PendingTxnDeleteModalSF from '../../../components/superUser/nodalTxn/PendingTxnDeleteModalSF'
import TabUI from '../../../widgets/output/TabUI'

const PendingTxnListPageUI = ({
  context, errorList, activeTab, onTabChange,
  transactionList, filteredTransactionList,
  onDeclineClick, declineSubmitted, onApproveClick, approveSubmitted, selectedTxnId,
  deleteMode, onDeleteClick, onCancelDelete,
  searchFilter, onSearchFilterChange, onRefreshClick, onDownloadClick, onDownloadTotalBadgeType,
  onCopyToClipboard, copyToClipboardText,
  showDetails, onShowDetails, selectedReferenceId, eventList, totalAmountF1, subtotalsByTypeBadge,
  dailyPaymentsReport, reportDateISO, isCurrentDayReport, reportLoading,
  onPreviousReportClick, onNextReportClick, formatReportDate,
  onDailyPaymentsDownloadClick, dailyPaymentsDownloadMode,
  onSendDailyPaymentsEmailClick, emailSending
}) => {
  const isDailyPaymentsTab = activeTab === 'dailyPayments'
  const showSpinner = isDailyPaymentsTab
    ? reportLoading && !dailyPaymentsReport && !errorList
    : !transactionList && !errorList

  return (
    <SuperUserTxnPageUI context={context} className='pg_su_txn_l' topnav='transactions'
      headerText='Daily Payments report'
      page='pending' dimension='w768'
    >
      <div className='g_flex_h g_flex_left g_m_bottom_50'>
        <TabUI label='Daily Payments' active={isDailyPaymentsTab} onClick={() => onTabChange('dailyPayments')} />
        <TabUI label='Pending transactions' active={!isDailyPaymentsTab} onClick={() => onTabChange('pendingTransactions')} />
      </div>

      {
        showSpinner &&
        <SpinnerComponentUI />
      }

      {
        errorList && errorList.length > 0 &&
        <GenericErrorUI error={errorList[0]} />
      }

      {
        isDailyPaymentsTab && !showSpinner &&
        <DailyPaymentsReportUI
          context={context}
          report={dailyPaymentsReport}
          reportDateISO={reportDateISO}
          isCurrentDayReport={isCurrentDayReport}
          onRefreshClick={onRefreshClick}
          onPreviousClick={onPreviousReportClick}
          onNextClick={onNextReportClick}
          formatReportDate={formatReportDate}
          onDownloadClick={onDailyPaymentsDownloadClick}
          downloadMode={dailyPaymentsDownloadMode}
          onSendEmailClick={onSendDailyPaymentsEmailClick}
          emailSending={emailSending}
        />
      }

      {
        !isDailyPaymentsTab && transactionList && transactionList.length !== 0 &&
        <div>
          <PendingTxnListUI context={context} transactionList={filteredTransactionList}
            onRefreshClick={onRefreshClick} onDownloadClick={onDownloadClick} onDownloadTotalBadgeType={onDownloadTotalBadgeType}
            onDeclineClick={onDeclineClick} declineSubmitted={declineSubmitted}
            onApproveClick={onApproveClick} approveSubmitted={approveSubmitted}
            totalAmountF1={totalAmountF1}
            subtotalsByTypeBadge={subtotalsByTypeBadge}
            deleteMode={deleteMode}
            onDeleteClick={onDeleteClick}
            selectedTxnId={selectedTxnId}
            searchFilter={searchFilter} onSearchFilterChange={onSearchFilterChange}
            onCopyToClipboard={onCopyToClipboard} copyToClipboardText={copyToClipboardText}
            eventList={eventList}
            showDetails={showDetails}
            onShowDetails={onShowDetails}
            selectedReferenceId={selectedReferenceId}
          />

          <PendingTxnDeleteModalSF context={context}
            onRefreshClick={onRefreshClick}
            deleteMode={deleteMode} onCancelDelete={onCancelDelete}
            selectedTxnId={selectedTxnId}
          />
        </div>
      }

      {
        !isDailyPaymentsTab && transactionList && transactionList.length === 0 && !showSpinner &&
        <div>
          <div className='g_flex_h g_flex_left'>
            <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
            <span className='g_m_left_100 g_large'><b>Pending Approval in Escrow Accounts</b></span>
          </div>
          <EmptyListUI
            context={context}
            createEnabled={false}
            createDisabledMessageLabel='No pending transactions'
          />
        </div>
      }
    </SuperUserTxnPageUI>
  )
}

export default PendingTxnListPageUI
